<template>
    <el-card class="yellow-widget">
        <div v-if="$slots.header" slot="header">
            <slot name="header"></slot>
        </div>
        <div class="row mt-4 mb-1">
            <div class="col-12 dashboard-lts-widget mix-blend-mode-multiple" v-loading="loading">
                <el-table
                    :data="statsTotal"
                    empty-text=" ">
                    <el-table-column
                        label="Leads"
                        label-class-name="text-center"
                        align="center">New
                    </el-table-column>
                    <el-table-column
                        prop="leads_today"
                        label="Today"
                        label-class-name="text-center"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="leads_yesterday"
                        label="Yesterday"
                        label-class-name="text-center"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="leads_mtd"
                        label="This Month"
                        label-class-name="text-center"
                        align="center">
                    </el-table-column>
                </el-table>
                <el-table
                    :data="statsTotal"
                    :show-header="false"
                    empty-text=" ">
                    <el-table-column
                        align="center">No Contact
                    </el-table-column>
                    <el-table-column
                        prop="nocontact_today"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="nocontact_yesterday"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="nocontact_mtd"
                        align="center">
                    </el-table-column>
                </el-table>
                <el-table
                    :data="statsTotal"
                    :show-header="false"
                    empty-text=" ">
                    <el-table-column
                        align="center">Junk
                    </el-table-column>
                    <el-table-column
                        prop="junk_today"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="junk_yesterday"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="junk_mtd"
                        align="center">
                    </el-table-column>
                </el-table>
                <el-table
                    :data="statsTotal"
                    :show-header="false"
                    empty-text=" ">
                    <el-table-column
                        align="center"><strong>Apps</strong>
                    </el-table-column>
                    <el-table-column
                        prop="apps_today"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="apps_yesterday"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="apps_mtd"
                        align="center">
                    </el-table-column>
                </el-table>
                <el-table
                    :data="statsTotal"
                    :show-header="false"
                    empty-text=" ">
                    <el-table-column
                        align="center"><strong>Approvals</strong>
                    </el-table-column>
                    <el-table-column
                        prop="approvals_today"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="approvals_yesterday"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="approvals_mtd"
                        align="center">
                    </el-table-column>
                </el-table>
                <el-table
                    :data="statsTotal"
                    :show-header="false"
                    empty-text=" ">
                    <el-table-column
                        align="center"><strong>Options</strong>
                    </el-table-column>
                    <el-table-column
                        prop="options_today"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="options_yesterday"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="options_mtd"
                        align="center">
                    </el-table-column>
                </el-table>
                <el-table
                    :data="statsTotal"
                    :show-header="false"
                    empty-text=" ">
                    <el-table-column
                        align="center"><strong>Settled</strong>
                    </el-table-column>
                    <el-table-column
                        prop="settled_today"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="settled_yesterday"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="settled_mtd"
                        align="center">
                    </el-table-column>
                </el-table>
            </div>

            <div class="col-12 mt-4 dashboard-lts-dialog" v-if="allowViewDetail">
                <button
                    class="btn btn-light-blue w-100"
                    @click="showDialog"
                >View Broker Breakdown
                </button>

                <el-dialog
                    :visible.sync="dialogLeadToSettlementVisible"
                    width="calc(100vw - 40px)"
                    max-height="calc(100vh - 80px)"
                    top="0"
                    style="margin-left:1px">

                    <!-- dialog header -->
                    <div slot="title" class="dialog-header">
                        <div class="row">
                            <div class="col-12">
                                <h3 style="text-transform: capitalize">Lead to Settlement - Broker Breakdown</h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 mt-4">
                                <!-- filter by refferer group -->
                                <el-select
                                    ref="leadToSettleReferrer"
                                    v-model="assignedReferrerFilter"
                                    class="w-25"
                                    remote
                                    clearable
                                    @change="changedReferrer"
                                    @clear="clearedReferrer"
                                    @focus="getReferrersInital"
                                    :loading="loadingReferrers"
                                    :remote-method="getReferrers"
                                    reserve-keyword
                                    placeholder="Filter By Referrer"
                                >
                                    <el-option-group label="Referrers">
                                        <el-option
                                            v-for="item in assignReferrersInitial"
                                            :key="item.id"
                                            :label="`${item.name}`"
                                            :value="item.id"
                                        ></el-option>
                                    </el-option-group>
                                </el-select>

                                <!-- filter by lead source -->
                                <el-select
                                    ref="leadToSettleSource"
                                    v-model="leadSourceFilter"
                                    class="w-25 ml-2"
                                    remote
                                    clearable
                                    @change="changedLeadSource"
                                    @clear="clearedLeadSource"
                                    @focus="getLeadSourcesInital"
                                    :loading="loadingLeadSources"
                                    :remote-method="getLeadSources"
                                    reserve-keyword
                                    placeholder="Filter By Lead Source"
                                >
                                    <el-option-group label="Lead Sources">
                                        <el-option
                                            v-for="item in leadSourcesInitial"
                                            :key="item.id"
                                            :label="`${item.name}`"
                                            :value="item.id"
                                        ></el-option>
                                    </el-option-group>
                                </el-select>

                                <el-date-picker
                                    v-model="selectedDate"
                                    type="date"
                                    format="MMM dd, yyyy"
                                    value-format="yyyy-MM-dd"
                                    :clearable="false"
                                    class="lead-settle-datepicker ml-3"
                                    style="width: auto !important"
                                ></el-date-picker>

                                <el-button
                                    type="success"
                                    slot="append"
                                    class="btn btn-light-green rounded-0 ml-3"
                                    :class="{'is-loading': loadingDetail}"
                                    style="margin-bottom: 2px"
                                    :icon="loadingDetail ? 'el-icon-loading' : 'el-icon-refresh'"
                                    @click="getLeadToSettlementDetail"
                                >Refresh
                                </el-button>

                            </div>
                        </div>
                    </div>

                    <!-- dialog body -->
                    <el-table
                        ref="leadToSettleTable"
                        :data="statsByBroker"
                        stripe
                        highlight-current-row
                        :border="false"
                        :show-summary="true"
                        :default-sort="{prop: 'broker_name', order: 'ascending'}"
                        v-loading="loadingDetail"
                        sum-text="Total"
                        class="mb-4">
                        <el-table-column
                            prop="broker_name"
                            label="Broker"
                            label-class-name="text-center"
                            class-name="font-weight-bold"
                            min-width="150"
                            show-overflow-tooltip
                            sortable>
                        </el-table-column>
                        <el-table-column label="Daily" label-class-name="text-center text-uppercase">
                            <el-table-column label="Leads" label-class-name="text-center">
                                <el-table-column
                                    prop="leads_today"
                                    label="New"
                                    label-class-name="text-center"
                                    sortable>
                                </el-table-column>
                                <el-table-column
                                    prop="nocontact_today"
                                    label="No Contact"
                                    label-class-name="text-center"
                                    sortable>
                                </el-table-column>
                                <el-table-column
                                    prop="junk_today"
                                    label="Junk"
                                    label-class-name="text-center"
                                    sortable>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column
                                prop="apps_today"
                                label="Apps"
                                label-class-name="text-center align-bottom"
                                sortable>
                            </el-table-column>
                            <el-table-column
                                prop="options_today"
                                label="Options"
                                label-class-name="text-center align-bottom"
                                sortable>
                            </el-table-column>
                            <el-table-column
                                prop="settled_today"
                                label="Settled"
                                label-class-name="text-center align-bottom"
                                sortable>
                            </el-table-column>
                        </el-table-column>

                        <el-table-column label="Month To Date" label-class-name="text-center text-uppercase">
                            <el-table-column label="Leads" label-class-name="text-center">
                                <el-table-column
                                    prop="leads_mtd"
                                    label="New"
                                    label-class-name="text-center"
                                    sortable>
                                </el-table-column>
                                <el-table-column
                                    prop="nocontact_mtd"
                                    label="No Contact"
                                    label-class-name="text-center"
                                    sortable>
                                </el-table-column>
                                <el-table-column
                                    prop="junk_mtd"
                                    label="Junk"
                                    label-class-name="text-center"
                                    sortable>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column
                                prop="apps_mtd"
                                label="Apps"
                                label-class-name="text-center align-bottom"
                                sortable>
                            </el-table-column>
                            <el-table-column
                                prop="options_mtd"
                                label="Options"
                                label-class-name="text-center align-bottom"
                                sortable>
                            </el-table-column>
                            <el-table-column
                                prop="settled_mtd"
                                label="Settled"
                                label-class-name="text-center align-bottom"
                                sortable>
                            </el-table-column>
                        </el-table-column>
                    </el-table>

                    <!-- dialog footer -->
                    <!-- <div slot="footer" class="dialog-footer row">
                      <div class="col-6 text-left">
                        <el-button type="success" class="btn btn-light-green rounded-0" @click="getLeadToSettlementDetail">Refresh</el-button>
                      </div>
                      <div class="col-6 text-right">
                        <el-button type="primary" class="btn btn-light-blue" @click="closeDialog">Close</el-button>
                      </div>
                    </div> -->

                </el-dialog>

            </div>
        </div>
    </el-card>
</template>

<script>
export default {
    props: {
        token: {
            type: String,
            required: true
        },
        dateScope: {
            type: Object,
            required: true
        },
        teamId: {
            type: [Number, String],
            required: false
        },
        brokerId: {
            type: Number,
            required: false
        },
        allowViewDetail: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            dialogLeadToSettlementVisible: false,
            statsByBroker: [],
            statsTotal: [],
            loading: false,
            loadingDetail: false,

            selectedDate: '',

            // referrer dropdown properties
            assignedReferrerFilter: '',
            assignReferrersInitial: [],
            loadingReferrers: false,

            // lead source dropdown properties
            leadSourceFilter: '',
            leadSourcesInitial: [],
            loadingLeadSources: false,


        };
    },
    mounted() {
        this.refreshData();
    },
    created() {
        this.$bus.$on("refreshed-data", value => {
            this.refreshData();
        });
    },
    computed: {},
    watch: {
        dateScope: {
            handler(newVal, oldVal) {
                if (this.$moment(newVal.endDate).isAfter(this.$moment(), 'day')) {
                    this.selectedDate = this.$moment().format('YYYY-MM-DD');
                } else {
                    this.selectedDate = this.$moment(newVal.endDate).format('YYYY-MM-DD');
                }
            },
            deep: true,
            immediate: true
        },
        selectedDate: {
            handler(newVal, oldVal) {
                this.getLeadToSettlementDetail();
            },
            deep: true
        },
        teamId: {
            handler(newVal, oldVal) {
                this.refreshData();
            },
            deep: true
        },
        brokerId: {
            handler(newVal, oldVal) {
                this.refreshData();
            },
            deep: true
        }
    },
    methods: {
        refreshData() {
            this.getLeadToSettlement();
        },
        async showDialog() {

            this.loadingDetail = true;
            this.dialogLeadToSettlementVisible = true;
            this.getLeadToSettlementDetail();
            let leadToSettleTable = this.$refs.leadToSettleTable;

            if (leadToSettleTable) {
                setTimeout(function () {
                    leadToSettleTable.doLayout();
                }, 1000);
            }

        },
        closeDialog() {

            this.dialogLeadToSettlementVisible = false;

            if (this.assignedReferrerFilter) {
                this.assignedReferrerFilter = '';
            }

        },
        async getLeadToSettlement() {

            this.loading = true;

            try {
                let res = await axios.get(`/api/v2/lead-to-settlement`, {
                    headers: {
                        Authorization: `Bearer ${this.token}`
                    },
                    params: {
                        endDate: this.$moment().format('YYYY-MM-DD'),
                        teamId: this.teamId,
                        brokerId: this.brokerId
                    }
                });

                this.statsTotal = res.data.statsTotal;


            } catch (err) {
                console.error(err);
            }

            this.loading = false;

        },

        async getLeadToSettlementDetail() {

            this.loadingDetail = true;

            try {
                let res = await axios.get(`/api/v2/lead-to-settlement`, {
                    headers: {
                        Authorization: `Bearer ${this.token}`
                    },
                    params: {
                        endDate: this.$moment(this.selectedDate).format('YYYY-MM-DD'),
                        teamId: this.teamId,
                        referrerId: this.assignedReferrerFilter,
                        leadSourceId: this.leadSourceFilter
                    }
                });

                this.statsByBroker = res.data.statsByBroker;


            } catch (err) {
                console.error(err);
            }

            this.loadingDetail = false;

        },

        async getReferrers(query) {
            try {
                this.loadingReferrers = true;
                let res = await axios.post(`/admin/referrers/list`, {
                    headers: {
                        Authorization: `Bearer ${this.token}`
                    },
                    params: {
                        query: query
                    }
                });
                this.assignReferrersInitial = res.data;
                this.loadingReferrers = false;
            } catch (err) {
                console.error(err);
            }
        },
        getReferrersInital() {
            if (!this.assignReferrersInitial.length) {
                this.getReferrers('');
            }
        },
        changedReferrer() {
            if (this.assignedReferrerFilter) {
                this.assignReferrerUsersInitial = [];
                this.getLeadToSettlementDetail();
            }
        },
        clearedReferrer() {
            this.assignReferrerUsersInitial = [];
            this.getLeadToSettlementDetail();
        },

        async getLeadSources(query) {
            try {
                this.loadingLeadSources = true;
                let res = await axios.get(`/api/v2/lead-sources`, {
                    headers: {
                        Authorization: `Bearer ${this.token}`
                    }
                });
                this.leadSourcesInitial = res.data;
                this.loadingLeadSources = false;
            } catch (err) {
                console.error(err);
            }
        },
        getLeadSourcesInital() {
            if (!this.leadSourcesInitial.length) {
                this.getLeadSources('');
            }
        },
        changedLeadSource() {
            if (this.leadSourceFilter) {
                this.leadSourcesInitial = [];
                this.getLeadToSettlementDetail();
            }
        },
        clearedLeadSource() {
            this.leadSourcesInitial = [];
            this.getLeadToSettlementDetail();
        }

    }
};
</script>

<style scoped>

</style>

<style>

.dashboard-lts-widget .el-table__empty-block {
    min-height: 30px;
}

.dashboard-lts-widget .el-table td {
    font-size: 12px;
    padding: 3px 0;
}

.dashboard-lts-widget .el-table th {
    font-size: 12px;
    padding: 5px 0;
}

.dashboard-lts-dialog .el-table__footer-wrapper .cell {
    text-align: left !important;
    font-weight: 900;
}

.dashboard-lts-dialog .el-dialog__wrapper {
    overflow: hidden;
}

.dashboard-lts-dialog .el-table__body-wrapper {
    max-height: calc(100vh - 420px);
    overflow-y: scroll;
}

.dashboard-lts-dialog .el-dialog__wrapper div[role=dialog] {
    width: calc(100vw - 40px);
    max-width: 2000px;
    position: fixed;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

.lead-settle-datepicker .el-input__inner {
    border-radius: 0;
    border-color: #ccc;
}

.lead-settle-datepicker .el-input__inner {
    border-radius: 0;
    border-color: #C0C4CC;
}

.lead-settle-datepicker.is-active .el-input__inner, .lead-settle-datepicker .el-input__inner:focus {
    border-color: #409EFF;
    outline: 0;
}

.dashboard-lts-dialog .el-dialog__body {
    padding: 10px 20px;
}

.dashboard-lts-dialog .el-table__body tr.current-row > td {
    background-color: #D4AF37 !important;
    color: white;
}

.dashboard-lts-dialog .el-table--enable-row-hover .el-table__body tr:not(.current-row):hover > td {
    background-color: #dae4ec !important;
}

.dashboard-lts-dialog .el-table__body tr:hover > td {
    cursor: pointer;
}

.dashboard-lts-dialog .el-dialog__close {
    font-size: 26px !important;
    font-weight: 900;
}

</style>
